<div class="content-wrapper container-xxl p-0 anmar-dashboard">
  <div class="content-body">
    <section>
      <div class="card">
        <div class="card-header"><h4 class="card-title mb-0">Company profile PDFs</h4></div>
      </div>
      <div *ngIf="loading" class="alert alert-info">Loading…</div>
      <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
      <div class="row">
        <div class="col-md-6" *ngFor="let locale of locales">
          <div class="card">
            <div class="card-body">
              <h5>{{ locale === 'ar' ? 'Arabic profile' : 'English profile' }}</h5>
              <p *ngIf="profile(locale) as item" class="text-muted mb-1">
                {{ item.original_name }} · {{ item.configured ? 'Configured' : 'Missing' }}
              </p>
              <a *ngIf="profile(locale)?.url" [href]="profile(locale).url" target="_blank" rel="noopener">Open current PDF</a>
              <input class="form-control mt-1" type="file" accept="application/pdf,.pdf" (change)="onFileSelected(locale, $event)" />
              <button class="btn btn-primary mt-1" type="button" [disabled]="uploading === locale" (click)="replace(locale)">
                {{ uploading === locale ? 'Uploading…' : 'Upload / replace' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
